export const formatCpf = (v: string): string => {
  if (!v) return ''
  const digits = v.replace(/\D/g, '').slice(0, 11)
  return digits
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2')
}

export const formatCnpj = (v: string): string => {
  if (!v) return ''
  const digits = v.replace(/\D/g, '').slice(0, 14)
  return digits
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d{1,2})$/, '$1-$2')
}

export const formatPhone = (v: string): string => {
  if (!v) return ''
  const digits = v.replace(/\D/g, '').slice(0, 11)
  if (digits.length <= 10) {
    return digits
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2')
  }
  return digits
    .replace(/^(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
}

export const formatCep = (v: string): string => {
  if (!v) return ''
  const digits = v.replace(/\D/g, '').slice(0, 8)
  return digits.replace(/^(\d{5})(\d)/, '$1-$2')
}

export const formatPis = (v: string): string => {
  if (!v) return ''
  const digits = v.replace(/\D/g, '').slice(0, 11)
  return digits
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{5})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{2})(\d{1})$/, '.$1-$2')
}

export const formatRg = (v: string): string => {
  if (!v) return ''
  const digits = v.replace(/[^\dxX]/g, '').slice(0, 9)
  return digits
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})([\dxX]{1})$/, '.$1-$2')
}

export const formatDate = (v: string): string => {
  if (!v) return ''
  const digits = v.replace(/\D/g, '').slice(0, 8)
  return digits
    .replace(/^(\d{2})(\d)/, '$1/$2')
    .replace(/^(\d{2})\/(\d{2})(\d)/, '$1/$2/$3')
}

export const formatMonthYear = (v: string): string => {
  if (!v) return ''
  const digits = v.replace(/\D/g, '').slice(0, 6)
  return digits.replace(/^(\d{2})(\d)/, '$1/$2')
}
